import { z } from 'zod';

export const FreeSampleOpportunitySchema = z.object({
  additional_emails: z.number().int().positive(),
  estimated_seconds: z.number().int().positive(),
});

export type FreeSampleOpportunity = z.infer<typeof FreeSampleOpportunitySchema>;

export const FreeSampleOpportunitySnapshotSchema = z.object({
  status: z.enum(['PENDING', 'IN_PROGRESS', 'PAUSED', 'COMPLETED', 'FAILED', 'CANCELED']),
  sample_complete: z.boolean(),
  completed_with_pro_entitlement: z.boolean(),
  emails_classified: z.number().int().nonnegative(),
  completed_sample_population: z.number().int().nonnegative().nullable(),
  scope_messages_total: z.number().int().nonnegative().nullable(),
  scope_precision: z.enum(['derived', 'floored']).nullable(),
  fetched_at: z.string().datetime({ offset: true }).nullable(),
});

export type FreeSampleOpportunitySnapshot = z.infer<typeof FreeSampleOpportunitySnapshotSchema>;
